import { createContext } from '@wordpress/element';
const SectionItemContext = createContext();
export default SectionItemContext;
